import { Links } from '@api/api';
import { linksApiClient } from '@api/clients';
import { useQuery, UseQueryResult } from 'react-query';

export const fetchSlugs = async (slugs: string[], params?): Promise<Links[]> => {
  const { data } = await linksApiClient.linksGet(
    { slugs },
    {
      params,
    },
  );

  return data;
};

export const useSlugs = (slugs: string[], params?): UseQueryResult<Links[]> => {
  return useQuery(['links', slugs], () => fetchSlugs(slugs, params));
};
